import useGetSupplierReport from '../hooks/useGetSupplierReport'
import {SupplierReportContext} from '../context'
import {Pagination} from '../../../utils/pagination'
import {KTCard} from '../../../_metronic/helpers'
import SupplierReportHeader from '../sections/header/SupplierReportHeader'
import SupplierReportTable from '../sections/table/SupplierReportTable'
import {useGetSupplierDropdown} from '../hooks/useGetSupplierDropdown'
import useGetEntityPerformanceChartData from '../hooks/useGetEntityPerformanceChartData'
import useGetProfitTrend from '../hooks/useGetProfitTrend'

function SupplierReport() {
  const {
    reportData,
    isLoading,
    onSearch,
    filters,
    onSortingChange,
    onPageChange,
    pagination,
    onDateChange,
    onChangeSupplierFilter,
    onDownloadCSV,
  } = useGetSupplierReport()

  const {
    entityPerformanceChartData,
    isLoading: isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
  } = useGetEntityPerformanceChartData('supplier')

  const {suppliers, isLoading: isSuppliersLoading} = useGetSupplierDropdown()

  const {
    profitTrendChartData,
    kpiData: profitTrendKpiData,
    weeklyBreakdownData: profitTrendWeeklyBreakdownData,
    isLoading: isProfitTrendDataLoading,
    onProfitTrendIdChange,
  } = useGetProfitTrend('supplier')

  const contextValue = {
    reportData,
    isLoading,
    onSearch,
    filters,
    onSortingChange,
    onPageChange,
    onDateChange,
    suppliers,
    isSuppliersLoading,
    onChangeSupplierFilter,
    onDownloadCSV,

    entityPerformanceChartData,
    isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,

    // Profit Trend Modal Data
    profitTrendChartData,
    profitTrendKpiData,
    profitTrendWeeklyBreakdownData,
    isProfitTrendDataLoading,
    onProfitTrendIdChange,
  }

  return (
    <KTCard>
      <SupplierReportContext.Provider value={contextValue}>
        <SupplierReportHeader />
        <SupplierReportTable />
        <Pagination pagination={pagination} onPageChange={onPageChange} />
      </SupplierReportContext.Provider>
    </KTCard>
  )
}

export default SupplierReport
